


















import DictMixin from '@/mixins/dict-mixin';
import PageMixin from '@/mixins/page-mixin';
import RoleServices from '@/services/role';
import { mock, Random } from 'mockjs';
import { mixins } from 'vue-class-component';
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class AddUser extends mixins(DictMixin, PageMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  roleSrv = new RoleServices();

  filterItems = [{ label: '用户姓名 / 生产域账号', key: 'userName', type: 'input' }];

  columns = [
    { title: '姓名', dataIndex: 'userName' },
    { title: '部门', dataIndex: 'deptName' },
    { title: '员工号', dataIndex: 'workId' },
    { title: '生产域账号', dataIndex: 'loginName' },
    { title: '邮箱', dataIndex: 'email' },
    { title: '手机号', dataIndex: 'mobileNo' }
  ];

  dataSource: any = [];

  selectedRows: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRows = rows;
  }

  @Watch('visible')
  async onVisibleChange() {
    if (!this.syncVisible) return false;
    this.filter = {};
    this.getList();
  }

  async getList() {
    this.loading = true;
    let res: any = await this.roleSrv.getUser({ ...this.filter, page: this.page, limit: this.limit });
    this.dataSource = res.datas;
    this.total = res.totalRecord;
    this.loading = false;
  }

  setFilter(filter: any) {
    this.filter = filter;
    this.getList();
  }

  async confirm() {
    this.$emit('success', this.selectedRows);
    this.syncVisible = false;
  }
}
